import React from "react";
import { Link } from "react-router-dom";
import { Clock, ArrowUpRight } from "lucide-react";

export const LEVEL_STYLES = {
  Beginner: "bg-emerald-500/10 text-emerald-400 border-emerald-500/25",
  Core: "bg-amber-500/10 text-amber-400 border-amber-500/25",
  Advanced: "bg-sky-500/10 text-sky-400 border-sky-500/25",
};

// Premium "research briefing" lesson card — shared by the Learn library and
// the Lesson page's Continue Exploring rail. Every field shown comes
// directly from the existing /learn API payload.
export const LessonCard = ({ t, testId, compact }) => (
  <Link
    to={`/learn/${t.id}`}
    data-testid={testId}
    className="lv-panel lv-panel-hover group flex h-full w-full flex-col p-5 text-left transition-transform duration-200 hover:-translate-y-0.5"
  >
    <div className="mb-3 flex items-center justify-between gap-2">
      <span className={`rounded border px-1.5 py-0.5 font-mono text-[10px] uppercase tracking-wide ${LEVEL_STYLES[t.level] || "bg-zinc-500/10 text-zinc-400 border-zinc-500/25"}`}>{t.level}</span>
      <span className="flex items-center gap-1.5 font-mono text-[11px] text-zinc-500"><Clock className="h-3 w-3" />{t.minutes} min</span>
    </div>
    <h3 className={`font-semibold leading-snug text-white transition-colors duration-200 group-hover:text-amber-100 ${compact ? "text-sm" : "text-base"}`}>{t.title}</h3>
    <p className="mt-2 flex-1 text-xs leading-relaxed text-zinc-400">{t.summary}</p>
    <div className="mt-4 flex items-center gap-1 border-t border-white/[0.06] pt-3 font-mono text-[11px] text-amber-400">
      Explore Lesson
      <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
    </div>
  </Link>
);
